var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "21px",
    viewBox: "0 0 23 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C9D3B2A7-8941-455B-872B-6114E20FECA8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.7986111,12.4347826 L14.8001389,12.4347826 L14.44625,12.1295652 C15.6848611,10.8408696 16.4305556,9.16782609 16.4305556,7.34782609 C16.4305556,3.28956522 12.7526389,0 8.21527778,0 C3.67791667,0 0,3.28956522 0,7.34782609 C0,11.406087 3.67791667,14.6956522 8.21527778,14.6956522 C10.2501389,14.6956522 12.1206944,14.0286957 13.5615278,12.9208696 L13.9027778,13.2373913 L13.9027778,14.1304348 L20.2222222,19.7713043 L22.1054167,18.0869565 L15.7986111,12.4347826 L15.7986111,12.4347826 Z M8.21527778,12.4347826 C5.06819444,12.4347826 2.52777778,10.1626087 2.52777778,7.34782609 C2.52777778,4.53304348 5.06819444,2.26086957 8.21527778,2.26086957 C11.3623611,2.26086957 13.9027778,4.53304348 13.9027778,7.34782609 C13.9027778,10.1626087 11.3623611,12.4347826 8.21527778,12.4347826 L8.21527778,12.4347826 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 63.1944444,
    height: 56.5217391
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Weboldal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FT1380-&-FT1390-Crimp-Machines---Lomar-header",
    transform: "translate(-754.000000, -26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(754.791667, 26.391304)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.222222, -18.086957)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Black",
    stroke: "none",
    fill: "#E10210",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ae73e0aefde83693044e308461fe8a9e.svg";
export { ForwardRef as ReactComponent };